import { parse } from "graphql";

import type { TypedDocumentNode } from "@apollo/client";

type MagazineMediaPublicationRequestResult = {
	magazineMediaPublicationRequest: {
		userErrors: string[];
		message?: string | null;
	};
};

type MagazineMediaPublicationRequestVariables = {
	input: {
		hotelID: string;
	};
};

/**
 * host の codegen はデプロイ済み GraphQL を introspection する。
 * この mutation は同じ変更でサーバーに追加するため、graphql タグにすると
 * デプロイ前の codegen が未知のフィールドとして失敗する。
 * 実行時の DocumentNode だけを組み立てる。
 */
export const MAGAZINE_MEDIA_PUBLICATION_REQUEST_MUTATION: TypedDocumentNode<
	MagazineMediaPublicationRequestResult,
	MagazineMediaPublicationRequestVariables
> = parse(`
	mutation MagazineMediaPublicationRequest($input: MagazineMediaPublicationRequestInput!) {
		magazineMediaPublicationRequest(input: $input) {
			userErrors
			message
		}
	}
`) as TypedDocumentNode<MagazineMediaPublicationRequestResult, MagazineMediaPublicationRequestVariables>;
